import { render, staticRenderFns } from "./StudentComingSoonScreen.vue?vue&type=template&id=51638c5e&scoped=true&"
import script from "./StudentComingSoonScreen.vue?vue&type=script&lang=js&"
export * from "./StudentComingSoonScreen.vue?vue&type=script&lang=js&"
import style0 from "./StudentComingSoonScreen.vue?vue&type=style&index=0&id=51638c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51638c5e",
  null
  
)

export default component.exports